export default function studentDashboardReducer(
  state = {
    indicatorToDos: [],
    indicators: [],
    visibilityByToDoGroup: {
      missed: false,
      lastTouched: 'missed',
    },
    expandedBeyondFourWeeks: false,
  },
  action,
) {
  switch (action.type) {
    case 'INDICATORS_V2.POPULATE_INDICATOR_TODOS':
      return {
        ...state,
        indicatorToDos: action.indicatorToDos,
      };
    case 'INDICATORS_V2.POPULATE_INDICATORS':
      return {
        ...state,
        indicators: action.indicators,
      };
    case 'INDICATORS_V2.UPDATE_INDICATOR_VISIBILITY':
      return {
        ...state,
        visibilityByToDoGroup: {
          ...state.visibilityByToDoGroup,
          ...action.updates,
          lastTouched: 'missed' in action.updates ? 'missed' : 'completed',
        },
      };
    case 'INDICATORS_V2.SET_EXPANDED_BEYOND_FOUR_WEEKS':
      return {
        ...state,
        expandedBeyondFourWeeks: !state.expandedBeyondFourWeeks,
      };
    case 'INDICATORS_V2.POPULATE_SINGLE_INDICATOR_PREEMPT':
      return {
        ...state,
        indicators: state.indicators.map(entry => {
          if (entry.indicator.uuid === action.indicatorUuid) {
            return {
              ...entry,
              customCompletedBy: new Date().toUTCString(),
              ...action.payload,
            };
          }
          return entry;
        }),
      };
    default:
      return state;
  }
}
